var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.355 12.229c0-.967.784-1.75 1.75-1.75h23.796c.966 0 1.75.783 1.75 1.75V27a1.75 1.75 0 0 1-1.75 1.75H8.105A1.75 1.75 0 0 1 6.355 27V12.23Zm1.75-.25a.25.25 0 0 0-.25.25v4.219h24.296v-4.22a.25.25 0 0 0-.25-.25H8.105ZM7.855 27v-9.052h24.296V27a.25.25 0 0 1-.25.25H8.105a.25.25 0 0 1-.25-.25Zm2.307-5.254a.75.75 0 0 0 0 1.5h7.183a.75.75 0 0 0 0-1.5h-7.183Z",
    fill: "currentColor"
  })));
};
export default SvgCard;